import { Component, OnInit } from '@angular/core';
import { AuthService } from './_services/authentication.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from './_services';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CharacterSheetSortsComponent } from './character-sheet/sorts/sorts.component';
import { SortService } from './_services/sort.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private sortService: SortService, public authService: AuthService, public userService: UserService, private modalService: NgbModal) {
  }

  ngOnInit(): void {
    //Make sure API is awake
    this.sortService.getSorts();
  }

  openFeedback(content: any) {
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result;
    return false;
  }

  onSubmitReport(reportValue: string) {
    if (reportValue === "")
    {
      this.modalService.dismissAll();
      return;
    }

    this.userService.report(reportValue)
    .subscribe({
      next: (result) => {
        this.modalService.dismissAll();
      },
      error: (e) => {
        console.error(e);
        this.modalService.dismissAll();
      }
    });
  }


}